$(function() {

  var topNavMenu = document.getElementById('topSubnav');
  // Reformats secondary navigation to fit new design
  if (topNavMenu) {
    nav_html = topNavMenu.innerHTML;
    updated_nav_html = '<div id="secondary-nav" class="clearfix"><div class="container"><div class="grid-100">' + nav_html + '</div></div></div>';
    topNavMenu.innerHTML = updated_nav_html;
    topNavMenu.id = 'topSubnav-01';
  }

  // Parallax Effect on Background Images
  var parallax = document.querySelectorAll(".section-parallax"),
      speed = 0.18;

  window.onscroll = function(){
    [].slice.call(parallax).forEach(function(el,i){

      var windowYOffset = window.pageYOffset - 1000,
          elementOffset = el.offsetTop,
          elBackgrounPos = "50% " + (windowYOffset - elementOffset) * speed + "px";

      el.style.backgroundPosition = elBackgrounPos;
    });
  };

  // Creates a smooth click and scroll based on hash
  $('a[href*=#]:not([href=#])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 400);
        return false;
      }
    }
  });

});

// Center Content <DIV> Function
function scrollCenterContent(itemContainer, offset) {
  $(itemContainer).each(function(i, section) {
    var content = $(section).parent();
    var h = $(content).height() - $(section).height() - offset;
    $(section).css("margin-top", h / 2);
  });
}

// $(‘div.unevenheights’).setMaxElementHeight()
$.fn.setElemMaxHeight = function(){
  this.removeAttr('style');
  return this.height(
    Math.max.apply(this, $.map( this , function(e){ return $(e).height() }) )
  );
}

$(document).ready( function() {
  // Hack to make banner 100% the screen
  $('#feature-content .grid-55').removeClass('grid-55 alpha').addClass('grid-100 center-content');
  $('#feature-content .grid-45').removeClass('grid-45 omega').addClass('grid-100');

  // set height of all pricing blocks to match
  $('.pricing-block').setElemMaxHeight()

  // Center content in <DIV>
  scrollCenterContent("#feature-content", 0);
  scrollCenterContent(".section-parallax .container", 0);
  scrollCenterContent(".cta-section .container", 0);

  // Move navigation
  if ( $( "#sectionTopper_short" ) ) {
    $('#topSubnav-01').insertAfter( $( "#sectionTopper_short" ) );
  }
  if ( $( "#sectionTopper_tall" ) ) {
    $('#topSubnav-01').insertAfter( $( "#sectionTopper_tall" ) );
  }

});

// Window.resize do these
$(window).resize(function(){
  $('.pricing-block').setElemMaxHeight();

  scrollCenterContent("#feature-content", 0);
  scrollCenterContent(".section-parallax .container", 0);
  scrollCenterContent(".cta-section .container", 0);
});

// Detect image natural size and prevent from being too large in responsive view
$(window).load(function(){
  if('naturalWidth'in(new Image)){
    $('img').each(function(){
      var width=$(this)[0].naturalWidth;
      $(this).css('max-width',width);
    });
  }
});
